const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* Gravurephoto : masque les liens « Orders / Profil » du menu, charge la traduction du menu Qikify */
(() => {
  const st = document.createElement('style');
  st.textContent = 'header nav li:has(> a[href*="/account/orders"]), header nav li:has(> a[href*="/account/profile"]), .menu-drawer li:has(> a[href*="/account/orders"]), .menu-drawer li:has(> a[href*="/account/profile"]) { display: none !important; }';
  document.head.appendChild(st);
  const s = document.currentScript;
  if (!s || /^fr/.test(document.documentElement.lang || 'fr')) return;
  const e = document.createElement('script');
  e.src = s.src.split('?')[0].replace('constants.js', 'gp-menu-i18n.js') + '?v=3';
  e.defer = true;
  document.head.appendChild(e);
})();
